export default __webpack_public_path__ + "static/media/PrintMATE.4d96d293.mp4";